/**
 * Date/time display configuration.
 * Locale tracks the app's UI language (see `@/i18n`), reactively — switching
 * language also switches date formatting. Format can be overridden per component.
 * Dates are shown in the app's fixed UTC+3 zone unless overridden.
 */
import { intlLocale } from '@/i18n'
import { APP_TIME_ZONE } from '@/utils/appTime'

/** Reactive locale for date/time formatting (e.g. 'ru-RU'). Default when not passed. Tracks the app's UI language. */
export const defaultLocaleForDate = intlLocale

/**
 * Default date style for display (Intl.DateTimeFormat dateStyle).
 * 'long' = full locale date (e.g. April 29, 2024), 'short' = numeric, 'medium' = medium.
 */
export const defaultDateStyle: 'long' | 'short' | 'medium' = 'long'

/** IANA timezone for date display — the app's fixed UTC+3 zone, regardless of the browser's own (see `@/utils/appTime`). */
export const defaultTimeZone: string | undefined = APP_TIME_ZONE
